/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import fetchHelper from "../../services/fetchHelper";
import cn from "classnames";

export const CPTCheckBoxItem = ({ item, suggestions, apiName, shouldShow = false }) => {
  const [isChecked, setIsChecked] = useState(item.selected);
  const [isSuggested, setIsSuggested] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [showCode, setShowCode] = useState(shouldShow);

  useEffect(() => {
    const isSuggested = suggestions.some((suggestion) => suggestion === item.codeClinicId);
    setIsSuggested(isSuggested);
  }, [suggestions]);

  useEffect(() => {
    setShowCode(shouldShow || item.selected);
  }, [shouldShow]);

  const showStatus = (status) => {
    setIsSuccess(status);
    setTimeout(() => {
      setIsSuccess(false);
    }, 3000);
  };

  const updateCPTCodeStatus = async (checked) => {
    if (isLoading) return false;
    setIsChecked(checked);
    setIsSuccess(null);
    setIsLoading(true);
    try {
      if (checked) {
        const url = `/patientmanagement/rest/v2/interrogations/${item.interrogationId}/${apiName}`;
        await fetchHelper.put(url, {
          [`${apiName === "cpt_code" ? "cptCodeId" : "diagnosticCodeId"}`]: item.codeId,
        });
        item.selected = true;
      } else {
        const url = `/patientmanagement/rest/v2/interrogations/${item.interrogationId}/${apiName}/${item.codeId}`;
        await fetchHelper.delete(url);
        item.selected = false;
      }
      showStatus(true);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      showStatus(false);
      setIsChecked(!checked);
    } finally {
      setShowCode(shouldShow || item.selected);
    }
    setIsLoading(false);
    showStatus(false);
  };

  if (!item.codeName || item.codeName === "") return null;

  return (
    <div hidden={!showCode}>
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          position: "relative",
          flexWrap: "wrap",
          backgroundColor: "transparent",
        }}
        className="checkbox-container"
      >
        <label
          className="form-li"
          style={{
            flex: 1,
            marginBottom: 3,
            display: "flex",
            alignItems: "center",
          }}
        >
          {isSuggested && (
            <div
              className="triangle"
              style={{
                borderColor: "transparent transparent transparent rgb(0, 123, 255)",
                borderWidth: "7.5px 0 7.5px 13.0px",
                position: "absolute",
                left: "-20px",
              }}
            />
          )}
          <input
            type="checkbox"
            className="chk"
            disabled={isLoading}
            checked={isChecked}
            onChange={(e) => updateCPTCodeStatus(e.target.checked)}
          />
          <span className="chkmrk" />
          <span
            className="lbl-txt"
            style={{ display: "flex", flex: 1, color: isSuggested && "rgb(0, 123, 255)" }}
          >
            {item.codeName}
          </span>
        </label>
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
          />
        )}
        {isLoading && <div className="saving-teal-ico icon-64" style={{ marginLeft: 5, marginRight: 15 }} />}
        {isSuccess && !isLoading && (
          <div
            className={cn({ "check-ico": isSuccess }, { "close-ico": !isSuccess }, "icon-64")}
            style={{ marginLeft: 5, marginRight: 5 }}
          />
        )}
        <div style={{ width: 16, height: 18.4, marginRight: 5 }} />
      </div>
    </div>
  );
};
